export enum CustomerTypes {
  RETAILER = "RETAILER",
  BRAND = "BRAND",
  UNKNOWN = "UNKNOWN",
}
